module.exports = __webpack_public_path__ + "media/assets/images/flags/ie-b8e0ab8fef816c23b781c991c68f95a6.svg";